export default __webpack_public_path__ + "static/media/1912.cc99bb37.png";